import { usePlaygameConfig, useDayjs, useUserInfo } from '#imports'

interface PlaygameLoggerParams {
    identifier: string | null
    eventType?: string
    eventObject?: any
    direction: 'inbound' | 'outbound'
    provider?: { name: string, color: string }
}

export const usePlaygameLogger = () => {
    const { logGameEvents } = usePlaygameConfig()
    const { isStaff } = useUserInfo()

    return ({ identifier, eventType, eventObject, direction, provider }: PlaygameLoggerParams) => {
        if (!logGameEvents || !isStaff.value) return

        const timestamp = useDayjs()().format()
        const arrow = direction === 'inbound' ? 'Game \u2192 Host' : 'Host \u2192 Game'
        const providerLabel = provider ? `[${provider.name}]` : ''
        const id = identifier ?? ''

        const arrowColor = direction === 'inbound' ? 'color: #1EA896; font-weight: bold; font-size: 10px;' : 'color: #ff6b6b; font-weight: bold; font-size: 10px;'
        const providerColor = provider ? `color: ${provider.color}; font-weight: bold; font-size: 10px;` : 'color: #444; font-size: 10px;'

        console.log(
            `%c[${timestamp}] %c${arrow} %c${providerLabel} %c${id} %c${eventType ?? JSON.stringify(eventObject)}`,
            'color: #888; font-size: 10px;',
            arrowColor,
            providerColor,
            'color: #444; font-weight: bold; font-size: 10px;',
            'color: #60ff4e; font-weight: bold; font-size: 10px;'
        )

        if (eventObject && typeof eventObject === 'object') {
            console.log(eventObject)
        }
    }
}
